module.exports = __webpack_public_path__ + "static/media/nubuck_ladies_strap_black.f7568adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nubuck_ladies_strap_black.png
// module id = 118
// module chunks = 0